import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';
import { recursiveRemovePreserve } from '../utils/HistoryUtils';
import { updateNavbarState } from './navbar_actions';

export const ASSETS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('ASSETS');
const ASSETS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(ASSETS_CRUD_ACTION_CONSTANTS);

const originalFn = ASSETS_CRUD_ACTION_CREATORS.updateSuccess;
ASSETS_CRUD_ACTION_CREATORS.updateSuccess = function (proposal) {
	return function (dispatch, getState) {
		const { navbar } = getState();
		const { backlinkTitle, navbarBackgroundColor } = navbar;
		if (navbar && navbar.backlinkTo) {
			const [path, queryParams] = navbar.backlinkTo.split('?');
			const urlSearchParams = new URLSearchParams(queryParams);
			const params = recursiveRemovePreserve(urlSearchParams);
			const backlinkTo = `${path}?${params.toString()}`;
			dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor));
		}
		dispatch(originalFn(proposal));
	};
};

export { ASSETS_CRUD_ACTION_CREATORS };
